import { render } from "./ComCancelIconButton.vue?vue&type=template&id=3c3fc27e&ts=true"
import script from "./ComCancelIconButton.vue?vue&type=script&lang=ts"
export * from "./ComCancelIconButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__